import stubTrue from "lodash/stubTrue";

/**
 * @deprecated SearchCompetitorsPaid - top paid competitors --
 * This metric config has been deprecated and is no longer supported in the dashboards.
 */
export const SearchCompetitorsPaid = {
    id: "SearchCompetitorsPaid",
    properties: {
        component: "SearchCompetitors",
        title: "dashboard.metrics.titles.top.paid.competitors",
        family: "Website",
        state: "organicsearch_websites-competitorsKeywords",
        noCompare: true,
        dashboard: "true",
        apiController: "SearchCompetitors",
        availabilityComponent: "WsPaidKeywords",
        disableDatepicker: true,
        viewPermissions: {
            trafficSources: ["MobileWeb", "Desktop"],
        },
        apiParams: {
            endpoint: "widgetApi/SearchCompetitors/SearchCompetitorsPaid/Table",
            pageSize: "400",
        },
        isHidden: stubTrue,
        isDeprecated: true,
    },
    widgets: {
        single: {
            defaultType: "SearchCompetitorsPaid",
            SearchCompetitorsPaid: {
                properties: {
                    options: {
                        desktopOnly: false,
                        showLegend: false,
                        dashboardSubtitleMarginBottom: 15,
                    },
                    showMoreButtonItems: 5,
                },
                columns: [],
            },
        },
    },
};
